import {useState,useEffect} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageUploading from 'react-images-uploading';
/* -- biz9 import start -- */
import {Log,Num,Str,Status_Type} from "biz9-utility";
import {Image_Type,Image_Format,Image_Table,Image_Field,Image_Service,Image_Url,Image_Logic} from "biz9-image";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_Image} from "biz9-portal-app";
import {Store_Field} from "biz9-store";
import {Message,Type,Url,Field,Title} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Toast_Message,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
/* -- biz9 import end -- */
const Modal_Item_Image_Gallery_Edit = (props) => {
    const navigate = useNavigate();
    const [val_title,setValTitle] = useState('');
    const [val_description,setValDescription] = useState("");
    const [val_sub_page_title,setValSubPageTitle] =  useState("");
    const [hide_btn_image_post,setHideBtnImagePost] = useState(false);
    const [image_primary,setImagePrimary] = useState([]);
    const image_primary_max_count = 1;
    useEffect(() => {
        get_data(props);
    },[props]);
    async function get_data(data){
        clear_field();
        bind_field(data);
        bind_image(data);
    };
    async function clear_field(){
        setValTitle('');
        setValDescription('');
        setImagePrimary([]);
    }
    async function bind_field(data){
        // --  bind-image-gallery-fields --
        if(!Str.check_is_null(data.image_gallery.id)){
            //edit
            setValSubPageTitle(Title.LABEL_EDIT + " " + Str.get_table_by_name(Portal_Table.IMAGE_GALLERY));
            setValTitle(data.image_gallery.title);
            setValDescription(data.image_gallery.description);
        }else{
            //add
            setValSubPageTitle(Title.LABEL_ADD + " " + Str.get_table_by_name(Portal_Table.IMAGE_GALLERY));
            setValTitle('Image Gallery ' + Str.get_id());
            setValDescription('');
        }
    };
    async function bind_image(data) {
        // -- bind-image-gallery-image --
        if(!Str.check_is_null(data.image_gallery.image_filename)){
            setImagePrimary([data.image_gallery]);
            setHideBtnImagePost(true);
        }else{
             setHideBtnImagePost(false);
        }
    };
    const updateValTitle = (event) => {
        setValTitle(event.target.value);
    };
    const updateValSubNote = (event) => {
        setValDescription(event.target.value);
    };
    async function post_image_gallery_field(field,value,required){
        // -- post-image-gallery-field
        if(value.trim() === '' && required) {
            props.toast_error(Message.INPUT_REQUIRED);
        }else{
            //add
            if(Str.check_is_null(props.image_gallery.id)){
                props.toast_loading(Message.LOADING);
                let item_new = Data_Logic.get(Portal_Table.IMAGE_GALLERY,0,
                    {data:{
                        title:value,
                        title_url:Str.get_title_url(value),
                        setting_visible:"1",
                        parent_table:props.parent_table,
                        parent_id:props.parent_id
                    }});
                let option = {overwrite:true,clean:true};
                let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Portal_Table.IMAGE_GALLERY,item_new,option);
                props.onUpdate([data, ...props.image_gallerys]);
                props.toast_success(response.message);
            }else{
                //edit
                props.toast_loading(Message.LOADING);
                props.image_gallery[field] = value;
                if(field == Portal_Field.TITLE){
                    props.image_gallery[Portal_Field.TITLE_URL] = Str.get_title_url(value);
                }
                let option = {overwrite:true,clean:true};
                let [response,data] = await Portal_Remote_Data.post(App.get_url(Portal_Url.DATA_POST),Portal_Table.IMAGE_GALLERY,props.image_gallery,option);
                const update_image_gallerys = props.image_gallerys.map((item) => {
                if (item.id === props.image_gallery.id) {
                    return { ...item, [field]: value };
                }
                return item;
                });
                props.onUpdate(update_image_gallerys);
                props.toast_success(response.message);
            }
        }
    };
       async function onImagePrimaryChange(image_upload, addUpdateIndex){
           // -- post-image-gallery-image --
        Toast_Message.loading(Message.SAVING);
        setHideBtnImagePost(true);
        let image = Data_Logic.get(Image_Table.IMAGE,0,{parent:{parent_table:props.parent_table,parent_id:props.id},data:{base64:image_upload[0][Image_Field.BASE64],extension:Str.get_file_extension(image_upload[0][Image_Field.FILE][Image_Field.NAME])}});
        let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),[image]);
        if(response.status == Status_Type.SUCCESS){
            post_image_gallery_field(Image_Field.IMAGE_FILENAME,data[0][Image_Field.IMAGE_FILENAME],true);
            Toast_Message.success(response.message);
            setHideBtnImagePost(true);
            setImagePrimary([data[0]]);
        }else{
            Toast_Message.error(response.message);
            setHideBtnImagePost(false);
        }
        Toast_Message.dismiss();
    };
    const onImagePrimaryDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            setHideBtnImagePost(false);
            setImagePrimary([]);
            post_image_gallery_field(Image_Field.IMAGE_FILENAME,'',false);
            props.toast_success(Message.DELETED);
        }
    };
    return (
        <>
        {/* Edit Item */}
        <div className="modal new-modal fade" id="add_item" data-keyboard="false" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
        <div className="modal-header">
        <button type="button" className="close-btn" data-bs-dismiss="modal">
        <span>×</span>
        </button>
        </div>
        </div>
        </div>
        </div>
        {/* /Edit Item */}
        {/* Item */}
        <div className="modal new-modal fade" id="modal_edit_image_gallery" data-keyboard="false" data-backdrop="static">
        <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
        <div className="modal-header">
        <button type="button" className="close-btn" data-bs-dismiss="modal">
<span>×</span>
</button>
</div>
<div className="modal-body">
<div className="row">
<div className="col-md-12">
<div className="amt-wrap">
<div className="settings-card-head bg-light" style={{marginBottom:'15px'}} >
            <h4>{val_sub_page_title}</h4>
</div>
<div className="form-wrap" hidden={props.image_gallery.id==0}>
<ImageUploading
value={image_primary}
onChange={onImagePrimaryChange}
maxNumber={image_primary_max_count}
dataURLKey={Image_Field.BASE64}>
{({
        imageList,
        onImageUpload,
        onImageRemoveAll,
        onImageUpdate,
        isDragging,
        dragProps,
        }) => (
            <div className="upload__image-wrapper">
            <button hidden={hide_btn_image_post} className="btn btn-secondary mb-2"
            style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
            {...dragProps} >
            Image
            </button>
            &nbsp;
            {imageList.map((image, index) => (
                        <div key={index} className="image-item">
                        <img  src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} alt="" height="200" width="200" />
                        <div className="image-item__btn-wrapper">
                        <Link onClick={() => onImagePrimaryDelete()} to="#" className="mb-2" >
                        <FeatherIcon icon="trash-2" />
                        </Link>
                        </div>
                        </div>
                        ))}
            </div>
            )}
        </ImageUploading>
        </div>

        <div className="form-wrap">
<label className="form-label">
Title
<span className="text-danger ms-1">*</span>
</label>
<input value={val_title} onChange={updateValTitle} onBlur={() => post_image_gallery_field(Portal_Field.TITLE,val_title,true)} type="text" className="form-control" />
</div>

<div className="form-wrap"  hidden={props.image_gallery.id==0}>
<label className="form-label">
Description
</label>
<input value={val_description} onChange={updateValSubNote} onBlur={() => post_image_gallery_field(Field.DESCRIPTION,val_description,false)} type="text" className="form-control" />
</div>
</div>
</div>
<div className="col-md-12">
<Link  data-bs-dismiss="modal"  to="#"  className="btn btn-primary w-100">
{'Close'}
</Link>
</div>
</div>
</div>
</div>
</div>
</div>
{/* /Item */}
</>
);
};
export default Modal_Item_Image_Gallery_Edit;
